module.exports = __webpack_public_path__ + "static/media/left_logo.1c80b2f0.png";